var internet = {};
module['exports'] = internet;
internet.domain_suffix = require("./domain_suffix");



//////////////////
// WEBPACK FOOTER
// ./~/faker/lib/locales/en_au_ocker/internet/index.js
// module id = 707
// module chunks = 0